import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Form, Nav, Row, Tab } from "react-bootstrap";
import { MdApartment, MdBalance, MdLogout, MdMailOutline, MdOutlineCurrencyRupee, MdOutlineLocationOn, MdOutlinePhone, MdOutlineRemoveRedEye } from "react-icons/md";
import { PiBookmarkSimpleLight, PiLinkedinLogo, PiSuitcaseSimple } from "react-icons/pi";
import { FaArrowLeft, FaArrowRightLong, FaCheck, FaChevronRight, FaRegClock, FaRegUser } from "react-icons/fa6";
import { GoDotFill, GoPencil } from "react-icons/go";
import { SlEnergy } from "react-icons/sl";
import { RiUserLocationLine } from "react-icons/ri";
import { IoDocumentTextOutline } from "react-icons/io5";
import { LuUpload } from "react-icons/lu";
import { ReactComponent as HrmsLogo} from '../../assets/images/product-logo/talent-factor-logo.svg';
import userPic from "../../assets/images/about/digy-team-mem-4.png";
import CircleProgressBar from "../../Components/CircleProgressbar";
import ScrollToTop from "../../Components/ScrollToTop";

const CandidateDashboard = () => {
    let navigate = useNavigate();
    let [tabkey, setTabkey] = useState('pill-1');
    let [stepTabkey1, setStepTabkey1] = useState('jcstep-2');
    let [stepTabkey2, setStepTabkey2] = useState('jcstep-1');
    let [stepTabkey3, setStepTabkey3] = useState('jcstep-0');
    const steps = ['jcstep-1', 'jcstep-2', 'jcstep-3', 'jcstep-4'];

    let [viewApplication, setViewApplication] = useState(false);

    let [generalInfoEdit, setGeneralInfoEdit] = useState(false);
    let [preferencesEdit, setPreferencesEdit] = useState(false);

    return ( <>
    <ScrollToTop watch={viewApplication} />
    <Container fluid className="candidate-dashboard bg-body-tertiary" style={{ paddingTop: 72 }}>
        {/* Banner */}
        <Card body bg="transparent" style={{ minHeight: 270 }}>
            <div className="position-relative">
            {/* Logo part */}
            <div className="py-3 rounded-3 banner-bg-section">
                <Row className="g-3 justify-content-between">
                    <Col md={3} xl={2} className="d-none d-md-block"></Col>
                    <Col md={6} xl={8}>
                        <div className="vstack align-items-center">
                            <HrmsLogo width={306} height={92} className="hrms-talent-factor-logo" />
                            <div className="fs-3 fw-semibold text-secondary">Candidate Dashboard</div>
                        </div>
                    </Col>
                    <Col md={3} xl={2}>
                        <div className='mt-3 mt-sm-0 vstack gap-1 justify-content-center h-100'>
                            <CircleProgressBar percent={94} stroke={8} className='mx-auto' style={{ height: 90, width: 90 }} />
                            <div className="vstack text-dark text-center">
                                <span className="fw-medium">Profile Strength</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            {/* // Logo part // */}
            {/* User Details */}
            <div className="user-detail-section w-100">
                <div className="d-flex flex-column flex-md-row gap-3">
                    <img src={userPic} alt="user-picture" className="img-thumbnail rounded-4 p-2 ms-3" width={120} height={120} />
                    <div className="hstack pt-md-3 mt-md-3 flex-fill">
                        <div className="vstack">
                            <div className="fs-5 fw-semibold">Sarah Chen</div>
                            <div className="hstack gap-3">
                                <span className="hstack gap-2">
                                    <MdMailOutline size={16} className="text-primary" />
                                    <a href="mailto:sarah.chen@email.com" className="text-decoration-none link-dark">sarah.chen@email.com</a>
                                </span>
                                <span className="hstack gap-2">
                                    <MdOutlinePhone size={16} className="text-primary" />
                                    <a href="tel:+1 (555) 123-4567" className="text-decoration-none link-dark">+1 (555) 123-4567</a>
                                </span>
                                <span className="hstack gap-2">
                                    <MdOutlineLocationOn size={16} className="text-primary" />
                                    <span className="text-dark">San Francisco, USA</span>
                                </span>
                            </div>
                        </div>
                        <span role="button" className="link-secondary ms-auto" onClick={()=> navigate('/careers')}><MdLogout size={20} /></span>
                    </div>
                </div>
            </div>
            {/* // User Details // */}
            </div>
        </Card>
        {/* // Banner END // */}
        <Tab.Container id="candidate-tab" activeKey={tabkey}>
            <Nav variant="pills" fill className="nav-pills-primary rounded-2 border border-opacity-75 p-1 mt-2"
            onSelect={(k) => setTabkey(k)}>
                <Nav.Item>
                    <Nav.Link eventKey="pill-1" as='button' className='py-1 fw-medium hstack justify-content-center'>
                        <PiSuitcaseSimple size={18} className="me-2" />
                        <span>My Application</span>
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="pill-2" as='button' className='py-1 fw-medium hstack justify-content-center'>
                        <PiBookmarkSimpleLight size={18} className="me-2" />
                        <span>Saved Jobs</span>
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="pill-3" as='button' className='py-1 fw-medium hstack justify-content-center'>
                        <FaRegUser size={18} className="me-2" />
                        <span>Profile Data</span>
                    </Nav.Link>
                </Nav.Item>
            </Nav>
            <Tab.Content>
                {tabkey === 'pill-1' && <Tab.Pane className="pb-3" eventKey="pill-1">
                    {!viewApplication ? (<>
                        <div className="hstack mt-2">
                            <h5 className="fw-semibold">My Applications</h5>
                            <span className="fw-medium text-secondary ms-auto">3 active</span>
                        </div>
                        <Card body border="0" className="mt-2">
                            <div className="d-flex">
                                <div className="hstack gap-2">
                                    <div className="icon p-2 rounded-3 bg-light">
                                        <MdApartment size={22} className="text-secondary" />
                                    </div>
                                    <div className="vstack">
                                        <div className="fw-semibold">Senior Software Engineer</div>
                                        <div className="text-secondary">Digylax</div>
                                    </div>
                                </div>
                                <div className="hstack gap-2 ms-auto">
                                    <span className="badge rounded-4 badge-light-primary"><GoDotFill size={16} className="me-1" />Interview</span>
                                    <Button size="sm" variant="white" className="p-1" 
                                    onClick={() => setViewApplication(true)}>
                                        <FaChevronRight />
                                    </Button>
                                </div>
                            </div>
                            <div className="mt-2 hstack gap-2 text-secondary">
                                <span className="hstack gap-1"><MdOutlineLocationOn /> Mountain View, CA</span>
                                <span className="hstack gap-1"><FaRegClock /> Dec 15, 2024</span>
                            </div>
                            <div className="mt-2">
                                <div className="badge rounded-4 w-100 text-start fs-14 fw-medium badge-light-primary">
                                    <MdOutlineRemoveRedEye size={18} className="me-2" />
                                    Hiring manager viewed your profile 10mins ago
                                </div>
                            </div>
                            <div className="step-form tab-circle-joint mt-2">
                                <Nav variant="pills" className='justify-content-evenly pt-2 col-12 col-xl-8 mx-sm-auto tab-circle' 
                                activeKey={stepTabkey1} onSelect={(k) => setStepTabkey1(k)} defaultActiveKey={'jcstep-2'}>
                                    {steps.map((step, index) => (
                                        <Nav.Item key={step} className="align-items-center vstack w-auto">
                                            <Nav.Link as="button" eventKey={step} disabled
                                            className={`rounded-pill fw-medium px-2 ${steps.indexOf(stepTabkey1) >= index ? 'text-bg-success' : index === 2 ? 'text-bg-primary' : 'text-bg-light'}`}>
                                                {steps.indexOf(stepTabkey1) >= index ? 
                                                    <FaCheck size={16} />
                                                : 
                                                    <span>{index + 1}</span>
                                                }
                                            </Nav.Link>
                                            <small className={`fw-medium ${steps.indexOf(stepTabkey1) >= index ? 'text-success' : index === 2 ? 'text-primary' : 'text-dark'}`}>
                                                {index === 0 ? 'Applied' : index === 1 ? 'Screening' : index === 2 ? 'Interview' : 'Offered'}
                                            </small>
                                        </Nav.Item>
                                    ))}
                                </Nav>
                            </div>
                        </Card>
                        <Card body border="0" className="mt-2">
                            <div className="d-flex">
                                <div className="hstack gap-2">
                                    <div className="icon p-2 rounded-3 bg-light">
                                        <MdApartment size={22} className="text-secondary" />
                                    </div>
                                    <div className="vstack">
                                        <div className="fw-semibold">Staff Engineer</div>
                                        <div className="text-secondary">Digylax</div>
                                    </div>
                                </div>
                                <div className="hstack gap-2 ms-auto">
                                    <span className="badge rounded-4 badge-light-purple"><GoDotFill size={16} className="me-1" />Screening</span>
                                    <Button size="sm" variant="white" className="p-1" 
                                    onClick={() => setViewApplication(true)}>
                                        <FaChevronRight />
                                    </Button>
                                </div>
                            </div>
                            <div className="mt-2 hstack gap-2 text-secondary">
                                <span className="hstack gap-1"><MdOutlineLocationOn /> Menlo Park, CA</span>
                                <span className="hstack gap-1"><FaRegClock /> Dec 12, 2024</span>
                            </div>
                            <div className="step-form tab-circle-joint mt-2">
                                <Nav variant="pills" className='justify-content-evenly pt-2 col-12 col-xl-8 mx-sm-auto tab-circle' 
                                activeKey={stepTabkey2} onSelect={(k) => setStepTabkey2(k)} defaultActiveKey={'jcstep-1'}>
                                    {steps.map((step, index) => (
                                        <Nav.Item key={step} className="align-items-center vstack w-auto">
                                            <Nav.Link as="button" eventKey={step} disabled
                                            className={`rounded-pill fw-medium px-2 ${steps.indexOf(stepTabkey2) >= index ? 'text-bg-success' : index === 1 ? 'text-bg-primary' : 'text-bg-light'}`}>
                                                {steps.indexOf(stepTabkey2) >= index ? 
                                                    <FaCheck size={16} />
                                                : 
                                                    <span>{index + 1}</span>
                                                }
                                            </Nav.Link>
                                            <small className={`fw-medium ${steps.indexOf(stepTabkey2) >= index ? 'text-success' : index === 1 ? 'text-primary' : 'text-dark'}`}>
                                                {index === 0 ? 'Applied' : index === 1 ? 'Screening' : index === 2 ? 'Interview' : 'Offered'}
                                            </small>
                                        </Nav.Item>
                                    ))}
                                </Nav>
                            </div>
                        </Card>
                        <Card body border="0" className="mt-2">
                            <div className="d-flex">
                                <div className="hstack gap-2">
                                    <div className="icon p-2 rounded-3 bg-light">
                                        <MdApartment size={22} className="text-secondary" />
                                    </div>
                                    <div className="vstack">
                                        <div className="fw-semibold">iOS Developer</div>
                                        <div className="text-secondary">Digylax</div>
                                    </div>
                                </div>
                                <div className="hstack gap-2 ms-auto">
                                    <span className="badge rounded-4 badge-light-primary"><GoDotFill size={16} className="me-1" />Applied</span>
                                    <Button size="sm" variant="white" className="p-1" 
                                    onClick={() => setViewApplication(true)}>
                                        <FaChevronRight />
                                    </Button>
                                </div>
                            </div>
                            <div className="mt-2 hstack gap-2 text-secondary">
                                <span className="hstack gap-1"><MdOutlineLocationOn /> Cupertino, CA</span>
                                <span className="hstack gap-1"><FaRegClock /> Dec 12, 2024</span>
                            </div>
                            <div className="step-form tab-circle-joint mt-2">
                                <Nav variant="pills" className='justify-content-evenly pt-2 col-12 col-xl-8 mx-sm-auto tab-circle' 
                                activeKey={stepTabkey3} onSelect={(k) => setStepTabkey3(k)} defaultActiveKey={'jcstep-0'}>
                                    {steps.map((step, index) => (
                                        <Nav.Item key={step} className="align-items-center vstack w-auto">
                                            <Nav.Link as="button" eventKey={step} disabled
                                            className={`rounded-pill fw-medium px-2 ${steps.indexOf(stepTabkey3) >= index ? 'text-bg-success' : index === 0 ? 'text-bg-primary' : 'text-bg-light'}`}>
                                                {steps.indexOf(stepTabkey3) >= index ? 
                                                    <FaCheck size={16} />
                                                : 
                                                    <span>{index + 1}</span>
                                                }
                                            </Nav.Link>
                                            <small className={`fw-medium ${steps.indexOf(stepTabkey3) >= index ? 'text-success' : index === 0 ? 'text-primary' : 'text-dark'}`}>
                                                {index === 0 ? 'Applied' : index === 1 ? 'Screening' : index === 2 ? 'Interview' : 'Offered'}
                                            </small>
                                        </Nav.Item>
                                    ))}
                                </Nav>
                            </div>
                        </Card>
                    </>) 
                    :
                    (<>
                        <div className="hstack mt-2">
                            <Button variant="light" className="flat-btn text-secondary p-1 me-2" 
                            onClick={() => setViewApplication(false)}>
                                <FaArrowLeft />
                            </Button>
                            <h5 className="fw-semibold mb-0">Back To Application</h5>
                        </div>
                        <Card body border="0" className="mt-2">
                            <div className="d-flex">
                                <div className="hstack gap-2">
                                    <div className="icon p-2 rounded-3 bg-light">
                                        <MdApartment size={22} className="text-secondary" />
                                    </div>
                                    <div className="vstack">
                                        <div className="fw-semibold">Senior Software Engineer</div>
                                        <div className="text-secondary">Digylax</div>
                                    </div>
                                </div>
                                <div className="hstack gap-2 ms-auto">
                                    <span className="badge rounded-4 badge-light-primary"><GoDotFill size={16} className="me-1" />Interview</span>
                                </div>
                            </div>
                            <div className="mt-2 hstack gap-2 text-secondary">
                                <small className="hstack gap-1"><MdOutlineLocationOn /> Mountain View, CA</small>
                                <small className="hstack gap-1"><FaRegClock /> Dec 15, 2024</small>
                                <small className="hstack gap-1"><MdOutlineCurrencyRupee /> ₹180K - ₹250K</small>
                            </div>
                        </Card>
                        <Card body border="0" className="mt-2">
                            <div className="fw-semibold">Application Status</div>
                            <div className="step-form tab-circle-joint mt-2">
                                <Nav variant="pills" className='justify-content-evenly pt-2 col-12 col-xl-8 mx-sm-auto tab-circle' 
                                activeKey={stepTabkey1} onSelect={(k) => setStepTabkey1(k)} defaultActiveKey={'jcstep-2'}>
                                    {steps.map((step, index) => (
                                        <Nav.Item key={step} className="align-items-center vstack w-auto">
                                            <Nav.Link as="button" eventKey={step} disabled
                                            className={`rounded-pill fw-medium px-2 ${steps.indexOf(stepTabkey1) >= index ? 'text-bg-success' : index === 2 ? 'text-bg-primary' : 'text-bg-light'}`}>
                                                {steps.indexOf(stepTabkey1) >= index ? 
                                                    <FaCheck size={16} />
                                                : 
                                                    <span>{index + 1}</span>
                                                }
                                            </Nav.Link>
                                            <small className={`fw-medium ${steps.indexOf(stepTabkey1) >= index ? 'text-success' : index === 2 ? 'text-primary' : 'text-dark'}`}>
                                                {index === 0 ? 'Applied' : index === 1 ? 'Screening' : index === 2 ? 'Interview' : 'Offered'}
                                            </small>
                                        </Nav.Item>
                                    ))}
                                </Nav>
                            </div>
                        </Card>
                        <Card body border="0" className="mt-2">
                            <div className="fw-semibold">Job Description</div>
                            <Card.Text className="text-secondary">
                                The Software Engineer in the HR department will be responsible for developing, 
                                maintaining, and enhancing internal applications that streamline HR processes 
                                and initiatives. This role involves close collaboration with HR professionals 
                                to build user-friendly, robust software solutions that leverage advanced technologies, 
                                including AI, to improve efficiency and drive digital transformation within the department. 
                                The engineer will bridge the gap between technical development and human resource 
                                objectives to foster innovation across HR functions.
                            </Card.Text>
                        </Card>
                        <Card body border="0" className="mt-2">
                            <div className="fw-semibold">Key Responsibilities</div>
                            <ul className="mb-0 text-secondary">
                                <li>Design, develop, and maintain high-quality software solutions</li>
                                <li>Collaborate with cross-functional teams to define and implement features</li>
                                <li>Write clean, maintainable, and well-documented code</li>
                                <li>Participate in code reviews and contribute to technical discussions</li>
                                <li>Mentor junior team members and share knowledge</li>
                            </ul>
                        </Card>
                        <Card body border="0" className="mt-2">
                            <div className="fw-semibold">Requirments</div>
                            <ul className="mb-0 text-secondary">
                                <li>5+ years of experience in software development</li>
                                <li>Strong proficiency in modern programming languages and frameworks</li>
                                <li>Experience with cloud platforms and microservices architecture</li>
                                <li>Excellent problem-solving and communication skills</li>
                                <li>Bachelor's degree in Computer Science or related field</li>
                            </ul>
                        </Card>
                    </>)}
                </Tab.Pane>}
                {tabkey === 'pill-2' && <Tab.Pane className="pb-3" eventKey="pill-2">
                    <h5 className="fw-semibold mt-2">Saved Jobs</h5>
                    <Row md={2} xl={3} className="g-3">
                        <Col>
                            <Card border="0" className="h-100 px-3 py-2">
                                <div className="d-flex">
                                    <div className="hstack gap-2">
                                        <div className="icon p-2 rounded-3 bg-light">
                                            <MdApartment size={22} className="text-secondary" />
                                        </div>
                                        <div className="vstack">
                                            <div className="fw-semibold">Senior Software Engineer</div>
                                            <small className="text-secondary">Digylax</small>
                                        </div>
                                    </div>
                                    <div className="hstack gap-2 align-self-start ms-auto">
                                        <span className="hstack badge rounded-4 badge-light-danger">
                                            <FaRegClock size={12} className="me-1" /> 2d Left
                                        </span>
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <div className="badge rounded-4 w-100 text-start fs-14 fw-medium badge-light-warning">
                                        <SlEnergy size={16} className="me-2" /> Closing Soon - Don’t miss out!
                                    </div>
                                </div>
                                <div className="my-2 hstack gap-2 text-secondary">
                                    <small className="hstack gap-1"><MdOutlineLocationOn /> Los Gatos, CA</small>
                                    <small className="hstack gap-1 ms-auto"><MdOutlineCurrencyRupee /> ₹180K - ₹220K</small>
                                </div>
                                <Button variant="primary" className="rounded-2 w-100 mt-auto">
                                    Complete Application <FaArrowRightLong size={18} className="ms-2" />
                                </Button>
                            </Card>
                        </Col>
                        <Col>
                            <Card border="0" className="h-100 px-3 py-2">
                                <div className="d-flex">
                                    <div className="hstack gap-2">
                                        <div className="icon p-2 rounded-3 bg-light">
                                            <MdApartment size={22} className="text-secondary" />
                                        </div>
                                        <div className="vstack">
                                            <div className="fw-semibold">Cloud Architect</div>
                                            <small className="text-secondary">Digylax</small>
                                        </div>
                                    </div>
                                    <div className="hstack gap-2 align-self-start ms-auto">
                                        <span className="hstack badge rounded-4 badge-light-warning">
                                            <FaRegClock size={12} className="me-1" /> 5d Left
                                        </span>
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <div className="badge rounded-4 w-100 text-start fs-14 fw-medium badge-light-warning">
                                        <SlEnergy size={16} className="me-2" /> Closing Soon - Don’t miss out!
                                    </div>
                                </div>
                                <div className="my-2 hstack gap-2 text-secondary">
                                    <small className="hstack gap-1"><MdOutlineLocationOn /> Seattle, WA</small>
                                    <small className="hstack gap-1 ms-auto"><MdOutlineCurrencyRupee /> ₹200K - ₹250K</small>
                                </div>
                                <Button variant="primary" className="rounded-2 w-100 mt-auto">
                                    Complete Application <FaArrowRightLong size={18} className="ms-2" />
                                </Button>
                            </Card>
                        </Col>
                        <Col>
                            <Card border="0" className="h-100 px-3 py-2">
                                <div className="d-flex">
                                    <div className="hstack gap-2">
                                        <div className="icon p-2 rounded-3 bg-light">
                                            <MdApartment size={22} className="text-secondary" />
                                        </div>
                                        <div className="vstack">
                                            <div className="fw-semibold">Principal Engineer</div>
                                            <small className="text-secondary">Digylax</small>
                                        </div>
                                    </div>
                                    <div className="hstack gap-2 align-self-start ms-auto">
                                        <span className="hstack badge rounded-4 badge-light-warning">
                                            <FaRegClock size={12} className="me-1" /> 8d Left
                                        </span>
                                    </div>
                                </div>
                                <div className="my-2 hstack gap-2 text-secondary">
                                    <small className="hstack gap-1"><MdOutlineLocationOn /> Redmond, WA</small>
                                    <small className="hstack gap-1 ms-auto"><MdOutlineCurrencyRupee /> ₹200K - ₹250K</small>
                                </div>
                                <Button variant="primary" className="rounded-2 w-100 mt-auto">
                                    Complete Application <FaArrowRightLong size={18} className="ms-2" />
                                </Button>
                            </Card>
                        </Col>
                        <Col>
                            <Card border="0" className="h-100 px-3 py-2">
                                <div className="d-flex">
                                    <div className="hstack gap-2">
                                        <div className="icon p-2 rounded-3 bg-light">
                                            <MdApartment size={22} className="text-secondary" />
                                        </div>
                                        <div className="vstack">
                                            <div className="fw-semibold">Senior Software Engineer</div>
                                            <small className="text-secondary">Digylax</small>
                                        </div>
                                    </div>
                                    <div className="hstack gap-2 align-self-start ms-auto">
                                        <span className="hstack badge rounded-4 badge-light-danger">
                                            <FaRegClock size={12} className="me-1" /> 2d Left
                                        </span>
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <div className="badge rounded-4 w-100 text-start fs-14 fw-medium badge-light-warning">
                                        <SlEnergy size={16} className="me-2" /> Closing Soon - Don’t miss out!
                                    </div>
                                </div>
                                <div className="my-2 hstack gap-2 text-secondary">
                                    <small className="hstack gap-1"><MdOutlineLocationOn /> Los Gatos, CA</small>
                                    <small className="hstack gap-1 ms-auto"><MdOutlineCurrencyRupee /> ₹180K - ₹220K</small>
                                </div>
                                <Button variant="primary" className="rounded-2 w-100 mt-auto">
                                    Complete Application <FaArrowRightLong size={18} className="ms-2" />
                                </Button>
                            </Card>
                        </Col>
                        <Col>
                            <Card border="0" className="h-100 px-3 py-2">
                                <div className="d-flex">
                                    <div className="hstack gap-2">
                                        <div className="icon p-2 rounded-3 bg-light">
                                            <MdApartment size={22} className="text-secondary" />
                                        </div>
                                        <div className="vstack">
                                            <div className="fw-semibold">Cloud Architect</div>
                                            <small className="text-secondary">Digylax</small>
                                        </div>
                                    </div>
                                    <div className="hstack gap-2 align-self-start ms-auto">
                                        <span className="hstack badge rounded-4 badge-light-warning">
                                            <FaRegClock size={12} className="me-1" /> 5d Left
                                        </span>
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <div className="badge rounded-4 w-100 text-start fs-14 fw-medium badge-light-warning">
                                        <SlEnergy size={16} className="me-2" /> Closing Soon - Don’t miss out!
                                    </div>
                                </div>
                                <div className="my-2 hstack gap-2 text-secondary">
                                    <small className="hstack gap-1"><MdOutlineLocationOn /> Seattle, WA</small>
                                    <small className="hstack gap-1 ms-auto"><MdOutlineCurrencyRupee /> ₹200K - ₹250K</small>
                                </div>
                                <Button variant="primary" className="rounded-2 w-100 mt-auto">
                                    Complete Application <FaArrowRightLong size={18} className="ms-2" />
                                </Button>
                            </Card>
                        </Col>
                        <Col>
                            <Card border="0" className="h-100 px-3 py-2">
                                <div className="d-flex">
                                    <div className="hstack gap-2">
                                        <div className="icon p-2 rounded-3 bg-light">
                                            <MdApartment size={22} className="text-secondary" />
                                        </div>
                                        <div className="vstack">
                                            <div className="fw-semibold">Principal Engineer</div>
                                            <small className="text-secondary">Digylax</small>
                                        </div>
                                    </div>
                                    <div className="hstack gap-2 align-self-start ms-auto">
                                        <span className="hstack badge rounded-4 badge-light-warning">
                                            <FaRegClock size={12} className="me-1" /> 8d Left
                                        </span>
                                    </div>
                                </div>
                                <div className="my-2 hstack gap-2 text-secondary">
                                    <small className="hstack gap-1"><MdOutlineLocationOn /> Redmond, WA</small>
                                    <small className="hstack gap-1 ms-auto"><MdOutlineCurrencyRupee /> ₹200K - ₹250K</small>
                                </div>
                                <Button variant="primary" className="rounded-2 w-100 mt-auto">
                                    Complete Application <FaArrowRightLong size={18} className="ms-2" />
                                </Button>
                            </Card>
                        </Col>
                    </Row>
                </Tab.Pane>}
                {tabkey === 'pill-3' && <Tab.Pane className="pb-3" eventKey="pill-3">
                    <h5 className="fw-semibold mt-2">Profile Data</h5>
                    <Row md={2} xl={3} className="g-3">
                        <Col>
                            <Card border="0" className="h-100 px-3 py-2">
                                <div className="d-flex">
                                    <div className="hstack gap-2">
                                        <span className="icon hstack p-1 rounded-circle badge badge-light-primary">
                                            <FaRegUser size={14} />
                                        </span>
                                        <div className="fw-semibold">General Info</div>
                                    </div>
                                    <span className="ms-auto link-secondary" role="button" 
                                    onClick={() => setGeneralInfoEdit(!generalInfoEdit)}>
                                        {!generalInfoEdit ? <GoPencil size={18} /> : <FaCheck size={18} /> }
                                    </span>
                                </div>
                                <div className="vstack gap-1 mt-2">
                                    <div className="hstack gap-2">
                                        <MdMailOutline size={22} />
                                        {!generalInfoEdit ? 
                                            <a href="mailto:sarah.chen@email.com" 
                                            className="link-secondary form-control-sm form-control-plaintext">
                                                sarah.chen@email.com
                                            </a>
                                        :
                                            <Form.Control type="email" name="email" size="sm" placeholder="Email" autoComplete="off" 
                                            defaultValue={'sarah.chen@email.com'} />
                                        }
                                    </div>
                                    <div className="hstack gap-2">
                                        <MdOutlinePhone size={22} />
                                        {!generalInfoEdit ? 
                                            <a href="tel:++1 (555) 123-4567" 
                                            className="link-secondary form-control-sm form-control-plaintext">
                                                +1 (555) 123-4567
                                            </a>
                                        :
                                            <Form.Control type="tel" name="phoneNumber" size="sm" placeholder="Phone Nember" autoComplete="off" 
                                            defaultValue={'+1 (555) 123-4567'} />
                                        }
                                    </div>
                                    <div className="hstack gap-2">
                                        <MdOutlineLocationOn size={22} />
                                        {!generalInfoEdit ? 
                                            <span className="text-secondary form-control-sm form-control-plaintext">San Francisco, CA</span>
                                        :
                                            <Form.Control name="location" size="sm" placeholder="Location" autoComplete="off" 
                                            defaultValue={'San Francisco, CA'} />
                                        }
                                    </div>
                                    <div className="hstack gap-2">
                                        <PiLinkedinLogo size={22} />
                                        {!generalInfoEdit ?
                                            <a href="https://linkedin.com/in/sarahchen" target="_blank"
                                            className="link-secondary form-control-sm form-control-plaintext">
                                                https://linkedin.com/in/sarahchen
                                            </a>
                                        :
                                            <Form.Control type="url" name="linkedInUrl" size="sm" placeholder="LinkedIn Profile Link" autoComplete="off" 
                                            defaultValue={'https://linkedin.com/in/sarahchen'} />
                                        }
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col>
                            <Card border="0" className="h-100 px-3 py-2">
                                <div className="d-flex">
                                    <div className="hstack gap-2">
                                        <span className="icon hstack p-1 rounded-circle badge badge-light-primary">
                                            <PiSuitcaseSimple size={14} />
                                        </span>
                                        <div className="fw-semibold">Preferences</div>
                                    </div>
                                    <span className="ms-auto link-secondary" role="button" 
                                    onClick={() => setPreferencesEdit(!preferencesEdit)}>
                                        {!preferencesEdit ? <GoPencil size={18} /> : <FaCheck size={18} /> }
                                    </span>
                                </div>
                                <div className="vstack gap-1 mt-2">
                                    <div className="hstack justify-content-between">
                                        <div className="hstack gap-2">
                                            <RiUserLocationLine size={22} />
                                            <Form.Label htmlFor="open-to-relocate-check" className="text-secondary form-control-plaintext">Open to Relocate</Form.Label>
                                        </div>
                                        <Form.Check type="switch" id={`open-to-relocate-check`}
                                        className={`fs-5 hstack justify-content-end ${!preferencesEdit ? '' : 'cursor-pointer'}`} role="button" disabled={!preferencesEdit} />
                                    </div>
                                    <div className="hstack justify-content-between">
                                        <div className="hstack gap-2 w-75">
                                            <MdBalance size={22} />
                                            <Form.Label htmlFor="travelWillingness" className="text-secondary form-control-plaintext">Travel Willingness</Form.Label>
                                        </div>
                                        <div className="w-25 text-end">
                                            {!preferencesEdit ? 
                                                <span className="text-secondary form-control-plaintext">30%</span>
                                            :
                                                <Form.Control id="travelWillingness" placeholder="Travel Willingness" autoComplete="off" 
                                                defaultValue={'30'} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col>
                            <Card border="0" className="h-100 px-3 py-2">
                                <div className="d-flex">
                                    <div className="hstack gap-2">
                                        <span className="icon hstack p-1 rounded-circle badge badge-light-primary">
                                            <IoDocumentTextOutline size={14} />
                                        </span>
                                        <div className="fw-semibold">Documents</div>
                                    </div>
                                </div>
                                <Card bg="light" border="0" className="hstack gap-2 p-2 mt-2">
                                    <div className="icon p-2 rounded-3 badge badge-light-primary">
                                        <IoDocumentTextOutline size={22} />
                                    </div>
                                    <div className="vstack">
                                        <div className="fw-semibold">Sarah_Chen_Resume_2024.pdf</div>
                                        <small className="text-secondary">Updated Dec 2024</small>
                                    </div>
                                </Card>
                                <Button variant="outline-primary rounded-2 mt-2" as="label">
                                    <LuUpload size={16} className="me-2" /> Replace File
                                    <Form.Control type="file" accept=".pdf, .doc, .docx" hidden />
                                </Button>
                            </Card>
                        </Col>
                    </Row>
                </Tab.Pane>}
            </Tab.Content>
        </Tab.Container>
    </Container>
    </> );
}
 
export default CandidateDashboard;